import React from 'react';
import logoFull from '../src/assets/logo.png';
import logoIcon from '../src/assets/logo_optibuild.png';

interface OptiBuildLogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'full' | 'icon' | 'text';
  className?: string;
}

const OptiBuildLogo: React.FC<OptiBuildLogoProps> = ({ 
  size = 'md', 
  variant = 'full',
  className = '' 
}) => {
  const sizeClasses = {
    sm: 'h-6',
    md: 'h-8',
    lg: 'h-12',
    xl: 'h-16'
  };

  const textSizeClasses = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl',
    xl: 'text-4xl'
  };

  const iconSize = {
    sm: 24,
    md: 32,
    lg: 48,
    xl: 64
  };

  // Logo icon using image asset
  const LogoIcon = () => (
    <img 
      src={logoIcon}
      alt="OptiBuild"
      className={`${sizeClasses[size]} flex-shrink-0`}
      style={{ height: iconSize[size], width: 'auto' }}
    />
  );

  // Logo Text Component
  const LogoText = () => (
    <span className={`font-bold tracking-tight ${textSizeClasses[size]}`}>
      <span className="text-primary">Opti</span>
      <span className="text-foreground">Build</span>
    </span>
  );

  if (variant === 'icon') {
    return (
      <div className={`${className}`}>
        <LogoIcon />
      </div>
    );
  }

  if (variant === 'text') {
    return (
      <div className={`${className}`}>
        <LogoText />
      </div>
    );
  }

  // Full logo with text using image asset
  return (
    <div className={`${className}`}>
      <img 
        src={logoFull}
        alt="OptiBuild"
        className={`${sizeClasses[size]}`}
        style={{ height: iconSize[size], width: 'auto' }}
      />
    </div>
  );
};

// Simplified Logo for Small Spaces
export const OptiBuildLogoSimple: React.FC<OptiBuildLogoProps> = ({ 
  size = 'md', 
  className = '' 
}) => {
  const iconSize = {
    sm: 20,
    md: 24,
    lg: 32,
    xl: 40
  };

  return (
    <div className={`${className}`}>
      <img 
        src={logoIcon}
        alt="OptiBuild"
        style={{ height: iconSize[size], width: 'auto' }}
      />
    </div>
  );
};

export default OptiBuildLogo;